import { render, staticRenderFns } from "./IncomeDistReport.vue?vue&type=template&id=1bc8592a&scoped=true&"
import script from "./IncomeDistReport.vue?vue&type=script&lang=js&"
export * from "./IncomeDistReport.vue?vue&type=script&lang=js&"
import style0 from "./IncomeDistReport.vue?vue&type=style&index=0&id=1bc8592a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc8592a",
  null
  
)

export default component.exports